var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenericsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.49,
    height: 16.26,
    viewBox: "0 0 10.49 16.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21319",
    "data-name": "Group 21319",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drug_1_",
    "data-name": "drug (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M9.561,13.189H.927A.88.88,0,0,1,0,12.365V4.23A3.755,3.755,0,0,1,1.544,1.243V.274A.293.293,0,0,1,1.852,0H8.636a.294.294,0,0,1,.31.274v.969a3.753,3.753,0,0,1,1.54,2.987v8.135A.879.879,0,0,1,9.561,13.189ZM3.7,6.564a.309.309,0,0,0-.308.309v.617A.308.308,0,0,0,3.7,7.8h.927v.925a.309.309,0,0,0,.308.31h.618a.309.309,0,0,0,.308-.31V7.8h.925a.308.308,0,0,0,.309-.308V6.873a.309.309,0,0,0-.309-.309H5.86V5.639a.308.308,0,0,0-.308-.308H4.935a.308.308,0,0,0-.308.308v.925Z",
    transform: "translate(0 3.072)",
    fill: "#dedfe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6",
    "data-name": "Subtraction 6",
    d: "M10.178,0H.309A.29.29,0,0,0,0,.267V5.609a.29.29,0,0,0,.309.267h9.869a.29.29,0,0,0,.308-.267c0-2.838.011-4.8-.006-5.194S10.26,0,10.178,0Z",
    transform: "translate(0 7.504)",
    fill: "#1a4059"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36567",
    "data-name": "Path 36567",
    d: "M12.364,3H5.579a.87.87,0,0,0-.925.8V5.4a.818.818,0,0,0,.617.753.973.973,0,0,0,.308.048h6.785a.973.973,0,0,0,.308-.048.818.818,0,0,0,.617-.753V3.8a.87.87,0,0,0-.925-.8Z",
    transform: "translate(-3.726 -3)",
    fill: "#1a4059"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36569",
    "data-name": "Path 36569",
    d: "M17.393,35.234h-.925v-.925A.308.308,0,0,0,16.159,34h-.617a.308.308,0,0,0-.308.308v.925h-.925a.308.308,0,0,0-.308.308v.617a.308.308,0,0,0,.308.308h.925v.925a.308.308,0,0,0,.308.308h.617a.308.308,0,0,0,.308-.308v-.925h.925a.308.308,0,0,0,.308-.308v-.617A.308.308,0,0,0,17.393,35.234Z",
    transform: "translate(-10.607 -25.597)",
    fill: "#dedfe0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericsLogo);
export default __webpack_public_path__ + "static/media/GenericsLogo.8555decf0c7d293112e3f5c3c2e57ceb.svg";
export { ForwardRef as ReactComponent };